<template>
  <div class="video-control-container">
    <div v-if="pin" class="control-info pin"></div>
    <div v-if="isPlayingWhiteNoise" class="control-info noise"></div>
  </div>
</template>

<script>
export default {
  name: "CamstudyVideoControl",
  data () {
    return {
      isPlayingWhiteNoise: false,
    }
  },
  props: {
    user: {
      type: Object,
      default: function(){
        return {
          userId: null,
          screenShare: false,
          _createdAt: 0
        };
      }
    },
    pin: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$roomApi.addEventListeners((this._Events = _Events()), this);
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
}

function _Events() {
  return {
    room_cstudy_changeWhiteNoiseStatus(e) {
      const userId = e.userId;
      const whiteNoiseStatus = e.data.whiteNoiseStatus;

      if(this.user.userId === userId) {
        this.isPlayingWhiteNoise = whiteNoiseStatus === 'on';
      }
    }
  }
}

</script>

<style scoped lang="scss">
.video-control-container{
  position: absolute;
  left: 8px;
  bottom: 8px;
  display: flex;
  gap: 4px;
  z-index: 2;
  border-radius: 12px;
  .control-info{
    border-radius: 50%;
    width: 24px;
    height: 24px;

    &.pin{
      background: #016FF2 url('~@/assets/images/camstudy/ico_pin_white.svg') center no-repeat;
    }
    &.noise{
      background: #016FF2 url('~@/assets/images/camstudy/ico_noise_white.svg') center no-repeat;
    }
  }
}
</style>